import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//Components
import GridLicenze from '../../containers/gestione_licenze/GridLicenze';
import GestioneModuli from '../../containers/gestione_licenze/GestioneModuli';
import CreaLicenza from '../../containers/gestione_licenze/CreaLicenza';
import ModificaLicenza from '../../containers/gestione_licenze/ModificaLicenza';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class MultiViewGestioneLicenze extends Component {


    render() {
        
        switch (this.props.selected_view) {
            case '':
                return <GridLicenze />;
            case 'Crea Nuova':
                return <CreaLicenza />;
            case 'Modifica':
                return <ModificaLicenza />;
            case 'Estendi':
                return null;
            case 'Gestione Moduli':
                return <GestioneModuli />;
            default:
                return <GridLicenze />;
        }

    }
}

MultiViewGestioneLicenze.propTypes = {
    selected_view: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
    selected_view: state['multi-view-gestione-licenze'].selected_view
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MultiViewGestioneLicenze));